import { lazy, Suspense } from 'react'
import { Outlet, RouteObject } from 'react-router'
import { EffectiveEmployeeInfoProvider } from '@/pages/employee-data/employee-details/useEffectiveEmployeeInfo.tsx'
import { SuspenseLoading } from '@/common/components/SuspenseLoading.tsx'
import { EmployeeProfileProvider } from '@/pages/employee-data/employee-profile/useEmployeeProfileContext.ts'

const EmployeeDirectoryPage = lazy(() => import('@/pages/employee-data/employee-directory/EmployeeDirectoryPage.tsx'))
const EmployeeDetailsPage = lazy(() => import('@/pages/employee-data/employee-details/EmployeeDetailsPage.tsx'))
const EmployeeProfilePage = lazy(() => import('@/pages/employee-data/employee-profile/EmployeeProfilePage.tsx'))
const EmployeeDirectoryAsNonHcPage = lazy(() => import('@/pages/employee-data/employee-profile/EmployeeDirectoryAsNonHcPage.tsx'))
const DepartmentConfigPage = lazy(() => import('@/pages/employee-data/department-config/DepartmentConfigPage.tsx'))
const TeamConfigPage = lazy(() => import('@/pages/employee-data/team-config/TeamConfigPage.tsx'))


export const employeeDataRoutes: RouteObject = {
  path: 'employee-data',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <Suspense fallback={<SuspenseLoading />}><EmployeeDirectoryPage /></Suspense>,
    },
    {
      path: 'departments',
      element: <Suspense fallback={<SuspenseLoading />}><DepartmentConfigPage /></Suspense>,
    },
    {
      path: 'teams',
      element: <Suspense fallback={<SuspenseLoading />}><TeamConfigPage /></Suspense>,
    },
    {
      path: ':employeeId', element:
        <EffectiveEmployeeInfoProvider>
          <Suspense fallback={<SuspenseLoading />}>
            <EmployeeDetailsPage />
          </Suspense>
        </EffectiveEmployeeInfoProvider>,
    },
  ],
}

export const employeeDataUserRoutes: RouteObject = {
  path: 'employee-profile',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <Suspense fallback={<SuspenseLoading />}><EmployeeDirectoryAsNonHcPage /></Suspense>,
    },
    {
      path: ':employeeId', element:
      <EmployeeProfileProvider>
        <Suspense fallback={<SuspenseLoading />}>
          <EmployeeProfilePage />
        </Suspense>
      </EmployeeProfileProvider>,
    },
  ],
}